export const RESPONSIVE_MENU_PASSTHRU = {
  root: {
    class: "!top-full !right-0 !left-auto p-6 !border-none bg-white w-[289px] drop-shadow-md rounded-md",
  },
};
export const CARDS_1 = {
  root: { class: "bg-white pt-6 px-4 pb-4 max-w-[350px] md:max-w-[284px]" },
  body: { class: "p-0" },
  content: { class: "p-0" },
};
export const CARDS_2 = {
  root: { class: "bg-transparent shadow-none border-none" },
  body: { class: "flex flex-row pb-0 px-4 pb-4 pt-[21px]" },
  content: { class: "flex" },
};

export const getDropdownPt = () => ({
  list: {
    class: "py-3 px-0 list-none m-0 bg-white",
  },
  item: {
    class:
      "relative font-normal text-indigo-base leading-none m-0 px-5 py-3 border-0 rounded-none dark:text-white/80 \
      bg-white dark:bg-surface-600/60 hover:text-surface-700 hover:bg-surface-100 \
      dark:hover:text-white dark:hover:bg-surface-600/80 transition-shadow duration-200 \
      cursor-pointer overflow-hidden whitespace-nowrap",
  },
  token: {
    class:
      "inline-flex items-center py-1.5 px-3 rounded-[1.14rem] \
      bg-purple-50 dark:bg-surface-700 text-indigo-base dark:text-white/70 cursor-default",
  },
});
